/**
 * @generated SignedSource<<ac9ba7b8dfe70cbb600370f4c7373077>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightShortDetails_flight$data = {
  readonly forwardSegments: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"FlightShortDetailsSegments_segments">;
  }>;
  readonly id: string;
  readonly returnSegments: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"FlightShortDetailsSegments_segments">;
  }>;
  readonly " $fragmentType": "FlightShortDetails_flight";
};
export type FlightShortDetails_flight$key = {
  readonly " $data"?: FlightShortDetails_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightShortDetails_flight">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "FlightShortDetailsSegments_segments"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightShortDetails_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "forwardSegments",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "returnSegments",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "FlightType",
  "abstractKey": "__isFlightType"
};
})();

(node as any).hash = "e36e9031bb75f333cd62b102a5de0d33";

export default node;
